import ClasImpl from '@/serviceImpl/ClasImpl';
import {Profile} from '@/domain/entities/Profile';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getUsersUseCase = async (): Promise<Array<Profile> | undefined> => {
  const accessToken = getCredentialsOrThrow();

  try {
    return await ClasImpl.getUsers(accessToken);
  } catch (error) {
    console.error('Error fetching users', error);
    throw error;
  }

};

export default getUsersUseCase;